<template>
  <div class="page--login">
    <OverlayLoader v-if=true></OverlayLoader>
    <div class="login-left">
      <img class="login-bg" src="../../assets/images/login-pic.jpg">
      <img class="login-bg-m" src="../../assets/images/login-pic-m.jpg">
    </div>

    <div class="login-right">
      <div class="login-right-content">
        <!-- step 2 -->
        <template>
          <h1>Enter PIN</h1>
          <div class="form-row">
            <div class="form-cell">
              <div class="form-block form-block--pin">
                <p class="login-info">We’ve sent an email containing the activation PIN to: <b>{{email}}</b></p>
                <div class="inputs-row">
                  <input type="text" v-model="pin[0]" placeholder="-" @keyup="nextInput(2)">
                  <input type="text" v-model="pin[1]" placeholder="-" @keyup="nextInput(3)">
                  <input type="text" v-model="pin[2]" placeholder="-" @keyup="nextInput(4)">
                  <input type="text" v-model="pin[3]" placeholder="-">
                </div>
                <input type="text" v-model="code" class="hidden" @keyup.enter="login()" @keyup="error=''">
                <div class="form-error" v-if="error">
                  <i class="icon-error"></i>
                  {{error}}
                </div>
              </div>
              <p class="login-info">Haven’t received an email? <a>Try again</a></p>
              <button class="button--submit" @click="login()">Log in</button>
            </div>
            <div class="form-cell">
              <label>Log in with SSO</label>
              <p class="login-info">If you would like to get the PIN code without opening your Capgemini employee mailbox:</p>
              <button class="button--submit" @click="logWithSSO()">Log in with SSO</button>
            </div>
          </div>
        </template>
      </div>
      <div class="login-footer">All rights reserved by Capgemini. <br>Copyright © {{ new Date().getFullYear() }}</div>
    </div>
  </div>
</template>

<script>
import auth from '@/api/auth'
import OverlayLoader from "@/components/general/OverlayLoader";

export default {
name: "Authenticate",
  components: {OverlayLoader},
  data() {
  return {
    email: '',
    code: '',
    step: 1,
    pin: [],
    account: '',
    error: '',
    user: {}
  }
},
mounted() {
    if(this.$route.query.code) {
      this.email = this.$store.getters.email
      this.login(this.$route.query.code)
    }
  },
  methods: {
    nextInput (input) {
      document.querySelector('.inputs-row input:nth-child('+input+')').focus()
    },

  submitEmail() {
    auth.register({
      email: this.email
    }, () => {
      this.step = 2;
    }, (error) => {
      this.error = 'Invalid domain: Please use your business address or/and check spelling.'
      console.log(error)
    })
  },
  login(token) {
    let payload = {
      email: this.email,
      deviceID: "Browser",
      deviceName: "123",
      deviceType: "Browser"
    }
    if(this.$route.query.openCapgeminiCompanyID) {
      payload.openCapgeminiCompanyID = this.$route.query.openCapgeminiCompanyID
    }
    auth.validateSSOCode(payload, token,(response) => {
      if(response.code === 'ok') {
        this.$store.dispatch('setToken', response.token)
        this.$store.dispatch('setUserCompanies', response.companies)
        const openId = this.$route.query.openCapgeminiCompanyID;
        if(openId) {
          const targetCompany = response.companies && response.companies.find(c => String(c.idCompany) === openId);
          const slug = targetCompany ? (targetCompany.slug || this.$store.getters.capgeminiCompanySlug) : this.$store.getters.capgeminiCompanySlug;
          this.$store.dispatch('setInitLocation', null);
          this.$router.push(`/${slug}`);
          return
        }
        if(this.$store.getters.initLocation) {
          this.$router.push(this.$store.getters.initLocation)
          this.$store.dispatch('setInitLocation', null)
          return
        } else {
          this.$router.push('/company-select')
        }
      } else {
        this.error = 'Invalid activation PIN: please try again'
      }
    })
  },
  logWithSSO() {
    location.href = 'https://signin.capgemini.com/as/authorization.oauth2?response_type=code&client_id=capgeminiengage&redirect_uri=https%3A%2F%2Fengage.edge.capgemini.com%2Fauthenticate&state=webstage&scope=openid'  }
}
}
</script>

<style scoped>

</style>
